import "./ts/slider-image";
import "./ts/accordion";
import "./ts/hamburger";
//import "./ts/bundle";
import "./ts/user";
import "./ts/cart";
import "./ts/checkout";
import "./ts/houseNumber";
import "./ts/orderTypePopup";
import "./ts/mainProduct";
import "./ts/landing";
import "./ts/thankyou";
import "./ts/utm";
import "./ts/cookie";
import "./ts/clickEvents";
import "./ts/shopCardLink";
import "./main.css";
import "./ts/njamitoComponents";
import "./ts/cartCount";
import "./ts/sideCart";
import "./ts/cartTooltip";
import "./ts/stickyCartBar";
import "./ts/singleProductAddToCart";
import "./ts/productPromo";
import "./ts/counter";
import "./ts/heroMedia";
import "./ts/fitText";
import "./ts/referralShare";
import "./ts/newsletterForm";

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({disable: 'mobile'});

import "./ts/marquee"
import "./ts/heroProducts"
import "./ts/gsapAnimations"
